import React, { useCallback, useState } from 'react';
import EmailValidationError from '../../components/generalComponents/EmailValidation/EmailValidationError';

import { CHECK_USER_EXISTS } from '../../constants/apiUrls/apiUrls';
import LoginModalStore from '../../store/LoginModalStore';
import callApi from '../../utils/callApi';


function EmailValidatorField(props) {
  const { user, errorMessage } = props;
  const { authenticated } = user || false;
  const [userEmail, setUserEmail] = useState('');
  const [emailErrorMessage, setEmailErrorMessage] = useState('');

  const onInputChange = useCallback((e) => {
    const { value } = e.target;
    setUserEmail(value);
  }, [userEmail]);

  function onSubmit() {
    setEmailErrorMessage('');
    let URL = CHECK_USER_EXISTS;
    URL = URL.replace('{userEmailID}', `${userEmail}`);
    callApi(URL).then((res) => {
      if (res.data.status === 'ALREADY_IN_USE') {
        LoginModalStore.setShouldShowModal(true);
        setEmailErrorMessage('You already have an account please login!');
      } else if (res.data.status === 'NOT_OK') {
        setEmailErrorMessage('Please enter a valid email!');
      } else {
        setEmailErrorMessage('Choose an anchor');
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  return (
    <div className="email-validation-container container flex justify-between">
      <h3 className="white text-center">
        Please enter your email to check if you already have an account on Naked News
      </h3>
      <div className="email-validation container flex justify-center items-center">
        <input
          placeholder="example@email.com"
          type="text"
          value={userEmail}
          onChange={onInputChange}
        />
        <button className="btn btn-primary col-md-2 btn-red submit-email" onClick={onSubmit}>SUBMIT</button>
      </div>

      <EmailValidationError
        authenticated={authenticated}
        emailErrorMessage={emailErrorMessage}
      />
      {<h4 className="error-text text-center">
        {errorMessage}
      </h4>}
    </div>
  );
}

export default EmailValidatorField;
